<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>报表管理</el-breadcrumb-item>
      <el-breadcrumb-item>出库记录表</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="display: flex;justify-items: center">
      <el-date-picker
        v-model="reportRequestBody.selectDay"
        type="daterange"
        range-separator="至"
        size="mini"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="selectReportDataDay"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
      <el-select v-model="selectProductType" clearable value filterable placeholder="请选择产品类别"
                 style="width: 200px" size="mini" @change="getProductType">
        <el-option
          v-for="org in productTypeList"
          :key="org.productTypeName"
          :label="org.productTypeName"
          :value="org.productTypeName">
        </el-option>
      </el-select>
      <el-select v-model="selectProduct" clearable value filterable placeholder="请选择产品名称"
                 style="width: 200px" size="mini" @change="getProduct">
        <el-option
          v-for="org in productList"
          :key="org.productName"
          :label="org.productName"
          :value="org.productName">
        </el-option>
      </el-select>
      <el-select v-model="selectOrgId" v-if="orgLevel < 3 " clearable value filterable placeholder="请选择领用人"
                 style="width: 200px" size="mini" @change="getShop">
        <el-option
          v-for="org in shop"
          :key="org.id"
          :label="org.orgName"
          :value="org.orgName">
        </el-option>
      </el-select>
      <el-button size="mini" style="margin-left: 5px;" @click="loadReportCkData()">查询</el-button>
    </div>
    <el-table height="550px" :data="kpiDataList" fit border stripe="stripe"
              :header-cell-style="{background:'#eff3f8', color:'#333'}"
              ref="tableName"
              show-summary>
      <el-table-column
        align="center"
        prop="ckDate"
        label="出库日期"
        width="150"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="productType"
        label="产品类别"
        width="150"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="productName"
        label="产品名称"
        width="150"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="num"
        label="出库数量"
        width="150"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="psm"
        label="规格"
        width="150"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="shopName"
        label="领用人"
        width="150"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="productPrice"
        label="产品价格"
        width="150"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="outPrice"
        label="出库价格"
        width="150"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="comment"
        label="备注"
        width="150"
      >
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data(){
    return{
      userId:'',
      orgId:'',
      orgLevel:'',
      authorities:'',
      kpiDataList:[],
      area:[],
      shop:[],
      productTypeList:[],
      productList:[],
      selectProductType:'',
      selectProduct:'',
      selectAreaId:'',
      selectOrgId:'',
      reportRequestBody:{
        selectDay:'',
        startDate:'',
        endDate:'',
        selectMonth:'',
        startMonth:'',
        endMonth:'',
        shopId:0,
        areaId:0,
        consumptionName:'',
        consumptionTypeName:'',
        shopName:'',
        areaName:'',
      }
    }
  },
  methods:{
    async getArea(data){
      if (data !== ''){
        this.reportRequestBody.areaId = data;
        const {data:res} = await this.$http.post('/load/report/ck/org', this.reportRequestBody);
        this.shop = res.data;
      } else {
        this.reportRequestBody.areaId = 0;
      }
    },
    getProductType(data){
      if (data !== ''){
        this.reportRequestBody.consumptionTypeName = data;
      } else {
        this.reportRequestBody.consumptionTypeName = '';
      }
    },
    getProduct(data){
      if (data !== ''){
        this.reportRequestBody.consumptionName = data;
      } else {
        this.reportRequestBody.consumptionName = '';
      }
    },
    async getShop(data){
      if (data !== ''){
        this.reportRequestBody.shopName = data;
        // const {data:res} = await this.$http.get(`/org/users/${data}`);
        // this.users = res.data;
      } else {
        this.reportRequestBody.shopName = '';
      }
    },
    // async loadAreaOrgs(){
    //   const {data:res} = await this.$http.get(`/orgs/area/orgId/${this.orgId}`);
    //   if (res.code === 200){
    //     this.area = res.data;
    //   }
    // },
    async loadReportCkData(){
      if(this.reportRequestBody.selectDay == '' || this.reportRequestBody.selectDay == null){
        return this.$message.warning("请选择查询日期");
      }
      if (this.reportRequestBody.selectDay !== '' && this.reportRequestBody.selectDay != null){
        this.reportRequestBody.startDate = this.reportRequestBody.selectDay[0];
        this.reportRequestBody.endDate = this.reportRequestBody.selectDay[1];
      }

      if (this.orgLevel == 2){
        this.reportRequestBody.areaId = this.orgId;
      }
      if (this.orgLevel == 3){
        this.reportRequestBody.shopId = this.orgId;
      }

      const {data:res} = await this.$http.post(`/report/ck/data`, this.reportRequestBody);
      this.kpiDataList = res.data;

      await this.loadShop();
      await this.loadProduct();
      await this.loadProductType();
    },
    selectReportDataDay(data){
      if (data == null){
        this.reportRequestBody.selectDay = '';
      } else {
        this.reportRequestBody.selectDay = data;
      }
    },
    async loadShop(){
      const {data:res} = await this.$http.post('load/report/ck/org', this.reportRequestBody);
      this.shop = res.data;
    },
    //加载产品分类
    async loadProductType(){
      const {data:res} = await this.$http.post('load/report/ck/product/type', this.reportRequestBody);
      if (res.code === 200){
        this.productTypeList = res.data;
      }
    },
    //加载产品分类
    async loadProduct(){
      const {data:res} = await this.$http.post('load/report/ck/product', this.reportRequestBody);
      if (res.code === 200){
        this.productList = res.data;
      }
    },
  },

  created() {
    this.dayTip = true;
    this.orgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.orgLevel = window.sessionStorage.getItem("orgLevel");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.reportRequestBody.areaId = this.orgId;
    // if (this.orgLevel == 1){
    //   this.loadAreaOrgs();
    // }
    // if (this.orgLevel == 2){
    //   this.reportRequestBody.areaId = this.orgId;
    // }
    // if (this.orgLevel == 3){
    //   // this.reportRequestBody.orgLevel = this.orgLevel;
    //   this.reportRequestBody.shopId = this.orgId;
    // }
  }
}
</script>

<style lang="less" scoped>
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
    text-align: center !important;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/.el-input__inner{
  height: 30px;
  line-height: 30px;
}
/deep/.el-input__icon,.el-icon-date{
  line-height: 35px;
}
/deep/.el-input__icon, .el-range__icon, .el-icon-date{
  line-height: 25px;
}
/deep/.el-range-separator{
  line-height: 23px;
}
.dialog-footer{
  display: flex;
  margin: 30px 20px 20px 0;
  justify-content: center;
  width: 100%;
}
/deep/.el-button--text{
  color: #ecf5ff;
}
.el-table {
  overflow: visible !important;
  //overflow: auto !important;
}

/deep/.el-tabs--card>.el-tabs__header {
  border-bottom: 1px solid #E4E7ED;
}
/deep/.el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 10px;
}
/deep/.el-tabs__content {
  overflow: hidden;
  position: relative;
  height: 600px;
}
/deep/.el-table__body-wrapper .is-scrolling-left{
  height: 483px;
}
/deep/.el-tabs__content.el-table__fixed{
  height: 539px;
}
/deep/ .el-table__fixed{
  height: 100% !important;
}
/deep/ .el-table__fixed-right,.el-table__fixed-body-wrapper{
  height: 100% !important;
}

</style>



// WEBPACK FOOTER //
// src/components/ReportCk.vue